import { render, staticRenderFns } from "./leftLists.vue?vue&type=template&id=b905bf0c&"
import script from "./leftLists.vue?vue&type=script&lang=js&"
export * from "./leftLists.vue?vue&type=script&lang=js&"
import style0 from "./leftLists.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports